import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home2.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home2.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue')
    },
    {
      path: '/product-1',
      name: 'product-1',
      component: () => import('./views/ProductTerminal.vue')
    },
    {
      path: '/product-2',
      name: 'product-2',
      component: () => import('./views/ProductIot.vue')
    },
    {
      path: '/custom-case',
      name: 'custom-case',
      component: () => import('./views/CustomCase.vue')
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('./views/Solution.vue')
    },
    // {
    //   path: '/solution-1',
    //   name: 'solution-1',
    //   component: () => import('./views/BaseSolution.vue')
    // },
    // {
    //   path: '/solution-2',
    //   name: 'solution-2',
    //   component: () => import('./views/InnovateSolution.vue')
    // },
    // {
    //   path: '/solution-3',
    //   name: 'solution-3',
    //   component: () => import('./views/ParkGuidance.vue')
    // },
    {
      path: '/media-news',
      name: 'media-news',
      component: () => import('./views/MediaNews.vue')
    },
    {
      path: '/media-news-detail/:id',
      name: 'media-news-detail',
      component: () => import('./views/MediaNewsDetail.vue')
    },
    {
      path: '/partner',
      name: 'partner',
      component: () => import('./views/Partner2.vue')
    },
    // {
    //   path: '/manager',
    //   component: () => import('./views/manager/Home.vue'),
    //   children: [
    //     {
    //       path: 'login',
    //       name: 'ManagerLogin',
    //       component: () => import('./views/manager/Login.vue'),
    //     },
    //     {
    //       path: 'news',
    //       name: 'ManagerNews',
    //       component: () => import('./views/manager/News.vue'),
    //       meta: { requiresAuth: true }
    //     },
    //     {
    //       path: 'consult',
    //       name: 'ManagerConsult',
    //       component: () => import('./views/manager/Consult.vue'),
    //       meta: { requiresAuth: true }
    //     },
    //     {
    //       path: 'partner',
    //       name: 'ManagerPartner',
    //       component: () => import('./views/manager/Partner.vue'),
    //       meta: { requiresAuth: true }
    //     },
    //   ]
    // }
  ]
})
